import React from 'react';
import {
  Network, Database, Mail, Globe, ShieldQuestion, Bug,
  FileSearch, Eye, ScanLine, Layers, Layers3,
  ShieldCheck as ShieldCheckIcon, Image as ImageIcon, HelpCircle
} from 'lucide-react';
import { ToolKey } from '../../api/premiumService';

export const ORDER: ToolKey[] = [
  'leaked_data','emails','ips','ipwhois','subdomains',
  'typosquatting','names_tld','whois','dns_all_records','wafw00f',
  'wappalyzer','gau','spoofornot','screenshot'
];

export const icons: Record<ToolKey, JSX.Element> = {
  leaked_data:    <Database className="h-5 w-5" />,
  emails:         <Mail className="h-5 w-5" />,
  ips:            <Globe className="h-5 w-5" />,
  ipwhois:        <ShieldQuestion className="h-5 w-5" />,
  subdomains:     <Network className="h-5 w-5" />,
  typosquatting:  <Bug className="h-5 w-5" />,
  names_tld:      <FileSearch className="h-5 w-5" />,
  whois:          <Eye className="h-5 w-5" />,
  dns_all_records:<ScanLine className="h-5 w-5" />,
  wafw00f:        <ShieldQuestion className="h-5 w-5" />,
  wappalyzer:     <Layers className="h-5 w-5" />,
  gau:            <Layers3 className="h-5 w-5" />,
  spoofornot:     <ShieldCheckIcon className="h-5 w-5" />,
  screenshot:     <ImageIcon className="h-5 w-5" />
};

export const FallbackIcon = <HelpCircle className="h-5 w-5" />;
